<template>
    <div class="af-apply-with-option af-apply-with-linkedin">
        <div
            v-if="!$_me.id"
            class="af-apply-with-item afu-p-5 afu-flex afu-items-center afu-justify-center afu-shadow-lg afu-rounded-btn afu-bg-white afu-cursor-pointer afu-border afu-border-solid afu-border-transparent hover:afu-border-solid hover:afu-border hover:afu-border-secondary-light"
            @click="signInLinkedin()"
        >
            <img
                :src="getLogo"
                alt="Login with LinkedIn"
            >
            <span
                v-if="$mq !== 'sm'"
                class="afu-text-secondary afu-text-base afu-font-semibold afu-ml-2"
            >
                LinkedIn
            </span>
        </div>
        <C1Modal
            v-if="isModalOpen"
            modal-content-class="afu-p-4 md:afu-p-8 md:afu-pt-6"
            size="lg"
            @close="closeModal"
            @show="loadApplyWithWidget"
        >
            <template v-slot:header>
                <div class="afu-flex afu-items-center afu-justify-between afu-mb-4">
                    <div class="afu-flex afu-items-center">
                        <span class="afu-mr-3 afu-text-900">
                            <img
                                :src="getLogo"
                                alt="Apply with LinkedIn"
                                class="afu-mr-2"
                            >
                        </span>
                        <span class="afu-font-bold">
                            {{ $t('apply.apply_with_linkedin') }}
                        </span>
                    </div>
                    <a
                        href="#"
                        class="afu-text-gray-900 afu-text-2xl"
                        @click.stop.prevent="closeModal()"
                    >
                        <FontAwesomeIcon :icon="['fal', 'times']" />
                    </a>
                </div>
            </template>
            <template v-slot:body>
                <div
                    ref="aflinkedin"
                    name="widget-holder"
                    class="afu-mx-auto afu-my-10 afu-w-64"
                />
                <template v-if="spinner.register">
                    <C1Spinner
                        variant="primary"
                        small
                    />
                    <span class="afu-ml-2">{{ $t('apply.loading_resume') }}</span>
                </template>
            </template>
            <template v-slot:footer>
                <C1Alert
                    v-if="!!response.message"
                    variant="danger"
                >
                    <div><strong>{{ response.message_title }}</strong></div>
                    <span v-html="response.message" />
                </C1Alert>
            </template>
        </C1Modal>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    // import has  from 'lodash/has';
    import { Bus } from '@/utils/bus';
    import Cookie from '@/services/cookie';
    import linkedin from './linkedin.json';

    import C1Spinner from '@/components/C1Components/C1Spinner';
    import C1Modal from '@/components/C1Components/C1Modal';

    import ApplyWithMixin from './ApplyWithMixin';
    import ApplyMixin from '../JobView/Apply/ApplyMixin.vue';
    import LinkedInMixin from '@/components/Social/LinkedInMixin';

    export default {
        name: 'LinkedIn',

        components: {
            C1Spinner,
            C1Modal,
        },

        mixins: [ApplyWithMixin, ApplyMixin, LinkedInMixin],

        data() {
            return {
                jobUuid: '',
                integrationEnabled: 'no',
                integrationContext: '',
                isModalOpen: false,
                linkedInProfileData: linkedin,
                response: {
                    message_title: '',
                    message: '',
                },
                spinner: {
                    register: false,
                },
            };
        },

        async created() {
            this.jobUuid = this.$route.params.uuid;
            this.integrationEnabled = window?.afConfig?.linkedin_integration_enabled?.toLowerCase();
            this.is_register = true;
        },

        mounted() {
            // if (!this.$_me.id && this.$route.query?.af_linkedin_auth_code) {
            // } else if (this.$_me.id && this.$route.query?.af_linkedin_apply == 1) {
            //     this.openModal();
            // } else {
            //     console.log('here');
            // }
        },

        computed: {},

        methods: {
            ...mapActions('auth', {}),

            openModal() {
                this.isModalOpen = true;
            },

            closeModal() {
                this.isModalOpen = false;
            },

            loadApplyWithWidget() {
                const vm = this;
                if (this.integrationEnabled == 'yes') {
                    this.clientId = window?.afConfig?.linkedin_client_id;
                    this.integrationContext =
                        window?.afConfig?.linkedin_integration_context;
                } else {
                    this.clientId = process.env.VUE_APP_LINKEDIN_CLIENT_ID;
                    this.integrationContext =
                        process.env.VUE_APP_LINKEDIN_INTEGRATION_CONTEXT;
                }
                let linkedInScript = document.createElement('script');
                linkedInScript.setAttribute(
                    'src',
                    'https://www.linkedin.com/mjobs/awli/awliWidget',
                );
                this.$refs.aflinkedin.appendChild(linkedInScript);

                let widgetScript = document.createElement('script');
                widgetScript.setAttribute('id', 'awli-widget');
                widgetScript.setAttribute('type', 'IN/AwliWidget');
                widgetScript.setAttribute('data-company-job-code', this.jobUuid);
                widgetScript.setAttribute(
                    'data-integration-context',
                    this.integrationContext,
                );
                widgetScript.setAttribute('data-mode', 'BUTTON_DATA');
                widgetScript.setAttribute('data-callback-method', 'onProfileData');
                widgetScript.setAttribute('data-api-key', this.clientId);
                widgetScript.setAttribute('data-allow-sign-in', 'true');
                widgetScript.setAttribute('data-size', 'large');
                this.$refs.aflinkedin.appendChild(widgetScript);

                window.onProfileData = profileData => {
                    vm.$_loadProfileData(profileData);
                };
                // this.$_loadProfileData(this.linkedInProfileData);
            },

            $_loadProfileData(profileData) {
                const email = this.$_me.email || profileData.emailAddress;
                const userData = {
                    email: email,
                    first_name: profileData.firstName,
                    last_name: profileData.lastName,
                    contact_number: profileData.phoneNumber,
                    recaptcha_disable: true,
                    resume_data: profileData,
                };

                this.spinner.register = true;
                this.$_createGuestResume(userData)
                    .then(response => {
                        this.$_STORE_GUEST_RESUME(response.data);
                        const user = {
                            email: email,
                            first_name: profileData.firstName,
                            last_name: profileData.lastName,
                            contact_number: profileData.phoneNumber,
                        };
                        this.$_STORE_APPLY_USER(user);
                        if (this.$_me.id) {
                            Bus.$emit('reloadResumes');
                            this.$_STORE_APPLY_AS_EXISTING_USER();
                        } else {
                            this.$_STORE_APPLY_AS_GUEST_USER();
                        }

                        const applyData = {
                            email: email,
                            first_name: profileData.firstName,
                            last_name: profileData.lastName,
                            contact_number: profileData.phoneNumber,
                            resume_id: response.data.id,
                            token: this.$_job.token,
                        };

                        this.$_applyToJob({
                            jobUuid: this.$_job.uuid,
                            data: applyData,
                        })
                            .then(response => {
                                this.afterApply(response.data);
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    })
                    .finally(() => {
                        this.closeModal();
                    });
            },

            afterLogin(data) {
                const user = data.data;
                this.$_storeAllUserData(user);
                this.$_STORE_APPLY_USER({
                    email: user.email,
                    first_name: user.first_name,
                    last_name: user.last_name,
                    contact_number: user.contact_number,
                });
                Cookie.setToken(data.access_token);
                this.openModal();
            },
        },
    };
</script>

